/* Preserve Route's original controls and checkout handlers. */
(() => {
  const initialized = new WeakSet();
  let scheduled = false;

  function update() {
    scheduled = false;
    document.querySelectorAll('.pw-route-protection').forEach(widget => {
      const container = widget.parentElement;
      const link = container.querySelector('[data-checkout-without-coverage-link]');
      const details = widget.querySelector('.pw-cashback-see-details');
      if (link) {
        const label = 'Checkout without package protection';
        if (link.textContent !== label) link.textContent = label;
        if (link.getAttribute('aria-label') !== label) link.setAttribute('aria-label', label);
        if (details) {
          const size = `${parseFloat(getComputedStyle(details).fontSize) * 1.25}px`;
          if (link.style.fontSize !== size || link.style.getPropertyPriority('font-size') !== 'important') {
            link.style.setProperty('font-size', size, 'important');
          }
        }
      }
      const toggle = widget.querySelector('button[data-testid="info-icon-preferred-checkout"]');
      const description = widget.querySelector('.pw-coverage-description');
      if (toggle && description && widget.closest('[data-jamos-cart-drawer]') && !description.querySelector('[data-jamos-route-help]')) {
        const help = document.createElement('button');
        help.type = 'button';
        help.dataset.jamosRouteHelp = '';
        help.textContent = "what's this?";
        help.style.cssText = 'display:inline-block!important;font:inherit!important;font-size:75%!important;font-weight:400!important;text-decoration:underline!important;text-underline-offset:2px!important;margin-left:8px!important;padding:0!important;border:0!important;background:transparent!important;color:inherit!important;cursor:pointer!important;white-space:nowrap!important;';
        help.addEventListener('click', event => {
          event.stopPropagation();
          widget.querySelector('button[data-testid="info-icon-preferred-checkout"]')?.click();
        });
        description.appendChild(help);
      }
      // Initialize the cart-page panel once; later customer toggles remain untouched.
      if (toggle && widget.closest('.jamos-cart__summary') && !initialized.has(widget)) {
        initialized.add(widget);
        if (toggle.getAttribute('aria-expanded') === 'false') toggle.click();
      }
    });
  }

  function schedule() {
    if (!scheduled) {
      scheduled = true;
      requestAnimationFrame(update);
    }
  }
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
  window.addEventListener('resize', schedule, { passive: true });
  update();
})();
